module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-with-text-small-7ccc24d05154243bfc1762a43e9574f4.png";